function removeArray(arr: any[], value: string): any[] {
    const index = arr.indexOf(value);

    if (index > -1) {
        arr.splice(index, 1);
    }

    return arr;
}

// ----------------------------------------------------------------------------

export default removeArray;
